import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import MarketingHeader from "@/components/MarketingHeader";
import { FEATURE_GROUPS } from "@/lib/marketingNav";

export default function FeatureGroup() {
  const { slug } = useParams();
  const index = FEATURE_GROUPS.findIndex((g) => g.slug === slug);
  if (index === -1) return <Navigate to="/features" replace />;

  const group = FEATURE_GROUPS[index];
  const prev = FEATURE_GROUPS[index - 1];
  const next = FEATURE_GROUPS[(index + 1) % FEATURE_GROUPS.length];

  return (
    <div className="mkt-page" data-testid="page-feature-group">
      <MarketingHeader />

      <section className="mkt-hero">
        <Link to="/features" className="feat-back-link">← All Features</Link>
        <div className="mkt-eyebrow">◢ FEATURES · {String(index + 1).padStart(2, "0")} / {String(FEATURE_GROUPS.length).padStart(2, "0")}</div>
        <h1 className="mkt-h1">{group.title}</h1>
        <p className="mkt-sub">{group.summary}</p>
      </section>

      <section className="mkt-body">
        <div className="mkt-fcards">
          {group.items.map((item) => (
            <div className="mkt-fcard" key={item.label}>
              <h3 className="mkt-fcard-title">{item.label}</h3>
              <p className="mkt-fcard-blurb">{item.blurb}</p>
            </div>
          ))}
        </div>

        <div className="feat-group-nav">
          {prev ? (
            <Link to={`/features/${prev.slug}`} className="feat-group-nav-link" data-testid="feat-group-prev">
              ← {prev.title}
            </Link>
          ) : <span />}
          <Link to={`/features/${next.slug}`} className="feat-group-nav-link feat-group-nav-next" data-testid="feat-group-next">
            {next.title} →
          </Link>
        </div>
      </section>

      <section className="mkt-final-cta">
        <h2 className="mkt-h2">See it on your own pipeline</h2>
        <p className="mkt-sub">No card, no commitment — just your next solicitation.</p>
        <a className="mkt-cta-btn" href="/#demo" data-testid="feature-group-cta">Schedule a demo →</a>
      </section>
    </div>
  );
}
